<svg
    [attr.wdith]="width()"
    [attr.height]="height()"
    viewBox="0 0 200 200">
    <g [attr.transform]="'translate(' + x() + ',' + y() + ')'">
        @if (!hideLowerBox()) {
            <path
                d="M112.825 110.773L80.5394 91.513L99.0719 80.4487L131.348 99.7318L112.825 110.773Z"
                [attr.fill]="'var(--roof-box-bg-1)'" />

            <!-- lowerbox long side wall -->
            <path
                d="M112.825 115.325L80.5394 96.0355V91.5127L112.825 110.773V115.325Z"
                [attr.fill]="'var(--roof-box-bg-3)'" />

            <!-- lowerbox shade -->
            <path
                d="M133.544 115.731L112.996 115.448L114.273 109.911L131.102 99.8765L146.241 108.703L133.544 115.731Z"
                [attr.fill]="'var(--roof-shade-bg)'" />

            <!-- lowerbox short side wall -->
            <path
                d="M130.348 103.731L111.825 114.803V110.251L130.348 99.219V103.731Z"
                fill="'var(--roof-box-bg-2)'" />
        }

        <!-- upper box long side wall -->
        <path
            d="M110.444 106.02L89.5419 93.5359V89.5938L110.444 102.078V106.02Z"
            [attr.fill]="'var(--roof-box-bg-3)'" />

        <!-- upperbox shade -->
        <path
            d="M110.539 106.012L113.145 94.6544L114.649 92.1367L128.502 100.246L119.308 105.689L110.539 106.012Z"
            [attr.fill]="'var(--roof-shade-bg)'" />

        <!-- upperbox short side wall -->
        <path
            d="M121.03 99.6906L110.444 106.02V102.078L121.03 95.7598V99.6906Z"
            fill="'var(--roof-box-bg-2)'" />

        <!-- upper box top -->
        <path
            d="M110.444 102.078L89.5419 89.5938L100.119 83.27L121.03 95.7599L110.444 102.078Z"
            [attr.fill]="'var(--roof-box-bg-1)'" />
    </g>
</svg>
